import React from 'react';
import { Helmet } from 'react-helmet';

import { css } from '@emotion/core';

import { Footer } from '../components/Footer';
import SiteNav from '../components/header/SiteNav';
import { PostFullContent } from '../components/PostContent';
import { Wrapper } from '../components/Wrapper';
import IndexLayout from '../layouts';
import {
  inner,
  outer,
  SiteArchiveHeader,
  SiteHeader,
  SiteMain,
  SiteNavMain,
} from '../styles/shared';
import { NoImage, PostFull, PostFullHeader, PostFullTitle } from '../templates/post';
import { colors } from '../styles/colors';

const PageTemplate = css`
  .site-main {
    margin-top: 64px;
    padding-bottom: 4vw;
    background: #fff;
  }

  @media (prefers-color-scheme: dark) {
    .site-main {
      /* background: var(--darkmode); */
      background: ${colors.darkmode};
    }
  }

  .post-content img {
    width: 80%;
    max-width: 300px;
    height: auto;
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>عنّي - عبدالهادي الأندلسي</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header className="site-archive-header no-image" css={[SiteHeader, SiteArchiveHeader]}>
        <div css={[outer, SiteNavMain]}>
          <div css={inner}>
            <SiteNav isHome={false} />
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <div css={inner}>
          <article className="post page" css={[PostFull, NoImage]}>
            <PostFullHeader className="post-full-header">
              <PostFullTitle className="post-full-title">عنّي</PostFullTitle>
            </PostFullHeader>

            <PostFullContent className="post-full-content">
              <div className="post-content">
                {/* <h5>
                  A starter template for Gatsby <br /> GitHub: <a href="https://github.com/scttcper/gatsby-casper">scttcper/gatsby-casper</a>
                </h5> */}
                <img src="https://i.suar.me/ByKKd/l" alt=""/>
                <p>أنا عبدالهادي جعفر، شاب مُسلم من الجزائر، خرّيج علوم حاسب (IT). أحب البساطة في كل شيء وحل المشاكل بطرق ابداعية.
                </p>
                <p>مُغرم بحب اللغة العربية والهوية العربية، كتبت الخط العربي في مرحلة ما من حياتي، لذلك لا تستغرب أن هويتي الشخصية
                  كلها خطوط عربية. </p>
                <p>أكتب وأهتم بالتقنيات الحديثة وأصمم وأبرمج مشاريع رقمية وأحرص على اخراجها بجمالية دقيقة حتى في أصغر الأشياء
                  بحيث ترتكز على البساطة والخلوّ من التعقيد. </p>
                <p>سعيد بزيارتكم وأسعدُ أكثر بالتعرف عليكم، لذلك يمكنكم الاتصال بي هنا:  <a href="https://blog.abdelhadi.org/contact/">تواصل معي</a></p>
                <p>يمكنك أيضا أن تعرف قصتي مع التدوين والكتابة: <a href="https://blog.abdelhadi.org/the-first-blog-post-ten-years-later/">أطلقت مدونتي بعد انقطاع عشر سنوات (حكايات من 2006!)</a></p>
                {/* <ul>
                  <li>البريد الالكتروني: <a href='mailto:me@abdelhadi.org' target='_blank' class='url'>me@abdelhadi.org</a></li>
                  <li><a href='https://www.linkedin.com/in/djafer'>لينكدإن</a>.</li>
                  <li><a href='https://twitter.com/elh4di'>تويتر</a>. </li>
                  <li><a href='https://t.me/aelh4di'>التليجرام</a>.</li>
                </ul> */}
              </div>
            </PostFullContent>
          </article>
        </div>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
